// Module
var code = `<div class="betslip-overlay" ng-if="model.isBlocked"> <div class="lock col-sm-24"> <div class="text-sm-center"> <i class="n-i n-i-lock"></i> </div> <p class="text-sm-center"> {{model.errMessage | translate}} </p> </div> </div> `;
// Exports
var _module_exports =code;;
var path = '/betslip/betslipBlockOverlay.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;